import React from 'react';
import CustomModal from '../../baseComponents/gui/customModal/CustomModal';
import CustomButton from '../../features/customButton/ui/main/CustomButton';
import { safeHTML } from '../../../utils/safeHTML';
import { useTranslation } from '../../../translations';

export default function GiftNoticeModal({ title, buttons, images = [], subTitle, type, name, uid }) {
  const { t } = useTranslation();

  return (
    <CustomModal animation={['fade', 'scale', 'scale-bounce']}>
      <div className={`gift-notice gift-notice_${type}`}>
        <div className={'gift-notice__content'}>
          <div className={'gift-notice__info'}>
            <h2 className={'gift-notice__title'}>{safeHTML(t(title))}</h2>
            <div className={'gift-notice__text'}>{safeHTML(`${name} ${t(subTitle).replace('{{uid}}', uid)}`)}</div>
          </div>
          <div className={'gift-notice__image'}>
            {images.map((src, i) => (
              <img key={i} src={src} className={'gift-notice__image-item'} />
            ))}
          </div>
          <div className={'gift-notice__buttons'}>
            {buttons?.map(({ attr, action }, i) => (
              <CustomButton key={i} {...attr} />
            ))}
          </div>
        </div>
      </div>
    </CustomModal>
  );
}
